import Vue from "vue";
import App from "./App.vue";
import vueRouter from "vue-router";
import { routes } from "./router";
import store from "./store/store";
import VueTheMask from "vue-the-mask";
import VeeValidate from "./validate";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import DescriptionModal from './components/dashboard/decription.vue';
import { sanitizeBr } from "./utils/sanitize";


Vue.prototype.$eventBus = new Vue();

// F-14: available in every template as $sanitizeBr(...) for safe v-html rendering.
Vue.prototype.$sanitizeBr = sanitizeBr;

Vue.component('DescriptionModal', DescriptionModal);

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

Vue.use(VeeValidate, {
  classes: true,
  delay: 0,
  events: "blur"
});

Vue.use(VueTheMask);
Vue.use(vueRouter);
Vue.config.productionTip = false;

const router = new vueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // Role-pinned portals: a laboperator/mtclab user may ONLY reach their own
  // dashboard. Any attempt to navigate elsewhere (e.g. the Admin Dashboard or
  // any admin page) is redirected back. The `return` is required � without it
  // the redirect falls through to the unconditional next() below and the
  // original navigation is still allowed (the previous bug).
  const role = localStorage.getItem("role");
  if (role === "laboperator" && to.path !== "/lab/dashboard") {
    return next("/lab/dashboard");
  }
  if (role === "mtclab" && to.path !== "/mtclab/dashboard") {
    return next("/mtclab/dashboard");
  }
  next();
});

Sentry.init({
  Vue,
  dsn:
    "https://b0afd20eff6f4f7d95b4cdf3b310ca80@o1032370.ingest.sentry.io/6036854",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "gotmold.com", /^\//]
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  logErrors: true
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
